import { css } from 'styled-components';
export const TextStyles = /*#__PURE__*/css(["font-family:Open Sans,Arial,Helvetica,sans-serif;line-height:", ";"], props => props.withExtraSpace ? '1.75em' : '1.25em');